export default __webpack_public_path__ + "static/media/3.1aa7a38f.svg";